import React, { useState } from 'react';
import '../styles/GeneralStyles.css';
import imgStep1 from '../assets/img-step-1.png'
import imgColor1 from '../assets/img-corte-1.png'
import imgAnilloBodasPrev from '../assets/anillo-de-bodas-preview.webp'
import iconRadio1 from '../assets/ring-vector-1.svg'
import iconArrowLeft from '../assets/arrow-left.svg'
import iconArrowRight from '../assets/arrow-right.svg'

const Step4 = ({ nextStep, prevStep, handleInputChange, formData, isSubmitting }) => {
  const [selectedOption, setSelectedOption] = useState(formData?.cutStyle || null);

  const options = [
    {
      id: 1,
      icon: iconRadio1,
      text: "Brillante",
      value1: 0,
      value2: 0,
      value3: 0,
      value4: 0,
      title: "Corte Brillante",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ut orci in tellus dictum pharetra",
      image: imgStep1,
    },
    {
      id: 2,
      icon: iconRadio1,
      text: "Princesa",
      value1: -1800,
      value2: -3375,
      value3: -4500,
      value4: -5625,
      title: "Corte Princesa",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ut orci in tellus dictum pharetra",
      image: imgStep1,
    },
    {
      id: 3,
      icon: iconRadio1,
      text: "Ovalado",
      value1: -1800,
      value2: -3375,
      value3: -4500,
      value4: -5625,
      title: "Corte Ovalado",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ut orci in tellus dictum pharetra",
      image: imgColor1
    },
    {
      id: 4,
      icon: iconRadio1,
      text: "Cushion",
      value1: -1800,
      value2: -3375,
      value3: -4500,
      value4: -5625,
      title: "Corte Cushion",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ut orci in tellus dictum pharetra",
      image: imgStep1
    }
  ];

  const handleOptionSelect = (option) => {
    const selectedCaratId = formData?.carats?.selectedId;
    const valueKey = `value${selectedCaratId}`;
    const finalValue = selectedCaratId ? option[valueKey] : option.value1;

    setSelectedOption(option);
    handleInputChange('cutStyle', {
      ...option,
      value: finalValue
    });
  };

  return (
    <div className='container-large'>
      <div className='wrapp-principal-2-columns'>
        <div className="options-column">
          <div className='text-n-options'>
            <h2 className='heading-style-h3 text-align-center'>Selecciona el Corte del Diamante</h2>
            <p className='text-size-medium text-color-grey'>Eligiendo el que mejor refleje su estilo y personalidad</p>
            <div className="radio-options">
              {options.map((option) => (
                <label key={option.id} className="radio-label">
                  <input
                    type="radio"
                    name="cutStyle"
                    checked={selectedOption?.id === option.id}
                    onChange={() => handleOptionSelect(option)}
                  />
                  <img src={option.icon} className="radio-icon" alt="ring icon" />
                  <span className="radio-text">{option.text}</span>
                </label>
              ))}
            </div>
          </div>
          
          <div className="wrapp-btns">
            <button className="button-prev" onClick={prevStep}>
              <img src={iconArrowLeft} alt="arrow left" />
              Volver
            </button>
            <button 
              className="button" 
              onClick={nextStep}
              disabled={!selectedOption}
            >
              Siguiente
              <img src={iconArrowRight} alt="arrow right" />
            </button>
          </div>
        </div>
        
        <div className="preview-column">
          {selectedOption ? (
            <>
              <div className='imgOptionSelected'>
                <img 
                  src={selectedOption.image} 
                  alt={selectedOption.text}
                  className="ring-preview-image"
                />
              </div>
              <div className='textOptionSelected'>
                <h3 className="text-align-left">{selectedOption.title}</h3>
                <p className="text-style-medium text-align-left">
                  {selectedOption.description}
                </p>
              </div>
            </>
          ) : (
            <div className="no-selection-message">
              <img src={imgAnilloBodasPrev} className='imgPreviewNoText' alt="Preview anillo" />
              <div className='wrappNoSelectText'>
                <p className='heading-style-h4 text-weight-bold text-color-white'>Corte</p>
                <p className='text-size-large text-color-white text-align-left'>Por favor selecciona un corte</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Step4;
